<script lang="ts">
    import {pipe} from 'core/utils';
    import {loc} from 'shared/utils/pipes';
    import {isNullOrUndefined} from 'shared/utils/custom-utils';

    export let option: any;
</script>

{pipe(option, loc())}

{#if !isNullOrUndefined(option.count)}
    <span class="text-muted">{option.count}×</span>
{/if}